import { buildTrackingEnvelope, snakeCaseKeys } from './utils/trackingEnvelope';

const beaconBody = payload => {
  const body = JSON.stringify({ event: payload });
  if (typeof Blob === 'undefined') return body;

  return new Blob([body], { type: 'application/json' });
};

const sendPayload = (endpoint, payload) => {
  if (!endpoint || typeof navigator === 'undefined') return false;

  const body = beaconBody(payload);
  if (navigator.sendBeacon) {
    return navigator.sendBeacon(endpoint, body);
  }

  const request = new XMLHttpRequest();
  request.open('POST', endpoint, true);
  request.setRequestHeader('Content-Type', 'application/json');
  request.send(JSON.stringify({ event: payload }));
  return true;
};

export const trackClickstreamEvent = ({ endpoint, event, properties = {} }) => {
  if (!event) throw new Error('No event name passed to trackClickstreamEvent');

  const envelope = properties.eventId
    ? properties
    : buildTrackingEnvelope(event, properties);
  const payload = snakeCaseKeys({
    event,
    ...envelope,
    deviceSentTimestamp: Date.now(),
  });

  if (typeof window !== 'undefined') {
    window.dataLayerClickstream = window.dataLayerClickstream || [];
    window.dataLayerClickstream.push(payload);
  }

  return sendPayload(endpoint, payload);
};
